import {useCookies} from 'vue3-cookies'
import {Base64} from "js-base64";

export const {cookies} = useCookies();

export function setCookie(key, value, expires, domain) {
    const v = Base64.encode(value);
    cookies.set(key, v, expires, domain);
}

export function getCookie(key) {
    const value = cookies.get(key);
    if (value != null) {
        return Base64.decode(value);
    }
    return "";
}

export function setRawCookie(key, value, expires, domain) {
    cookies.set(key, value, expires, domain);
}

export function getRawCookie(key) {
    const value = cookies.get(key);
    if (value != null) {
        return value;
    }
    return "";
}

/*export function delCookie(key) {
    cookies.remove(key, AppConfig.Instance.appDomainName);
}*/



